export default __webpack_public_path__ + "static/media/about-player.de85cec3.png";